import React from 'react'
import { NotificationsContext } from '../context/notificationContext'

export const useNotifications = () => {
  return React.useContext(NotificationsContext);
}
